import { NgModule } from '@angular/core';

import { UnauthorizedComponent } from './core/components/unauthorized/unauthorized.component';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './core/components/errors/not-found/not-found.component';
import { MsalGuard } from '@azure/msal-angular';
import { PortalGuard } from './auth/guards/portal-guard.service';
import { FleetManagerGuard } from './auth/guards/fleet-manager-guard.service';
import { environment } from '../environments/environment';
import { DeveloperGuard } from './auth/guards/developer-guard.service';

export const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: 'employee', redirectTo: 'auth/internal-login', pathMatch: 'full' },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: 'auth',
    loadChildren: 'app/auth/auth.module#AuthModule'
  },
  {
    path: 'fleet-manager',
    loadChildren: 'app/fleet-manager/fleet-manager.module#FleetManagerModule',
    canActivate: environment.disableAdAuthentication
      ? [FleetManagerGuard]
      : [MsalGuard, FleetManagerGuard ]
  },
  {
    path: 'portal',
    loadChildren: 'app/portal/portal.module#PortalModule',
    canActivate: environment.disableAdAuthentication
      ? [PortalGuard]
      : [MsalGuard, PortalGuard]
  },
  {
    path: 'carrier',
    loadChildren: 'app/carrier/carrier.module#CarrierModule'
  },
  {
    path: 'developer',
    loadChildren: 'app/developer/developer.module#DeveloperModule',
    canActivate: environment.disableAdAuthentication
      ? [DeveloperGuard]
      : [MsalGuard, DeveloperGuard]
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts